import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import HeroLayout from "../components/HeroLayout";
import SEO from "../components/SEO";

function SinglePost() {
  const { slug } = useParams();

  const [post, setPost] = useState(null);
  const [allCategories, setAllCategories] = useState([]);
  const [allTags, setAllTags] = useState([]);

  useEffect(() => {
    // ✅ Scroll to top when slug changes
    window.scrollTo({
      top: 0,
      behavior: "smooth", // remove "smooth" if you want instant
    });

    const fetchData = async () => {
      try {
        const [postRes, catRes, tagRes] = await Promise.all([
          fetch(
            `https://luxurygoldentriangle.com/bkadmn/wp-json/wp/v2/posts?slug=${slug}&_embed`
          ),
          fetch(
            `https://luxurygoldentriangle.com/bkadmn/wp-json/wp/v2/categories?per_page=5`
          ),
          fetch(
            `https://luxurygoldentriangle.com/bkadmn/wp-json/wp/v2/tags?per_page=20&_fields=id,name,slug`
          ),
        ]);

        const postData = await postRes.json();
        const catData = await catRes.json();
        const tagData = await tagRes.json();

        setPost(postData[0] || null);
        setAllCategories(catData);
        setAllTags(tagData);

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [slug]);

  const featuredImage =
    post?._embedded?.["wp:featuredmedia"]?.[0]?.source_url;

  const authorName = post?._embedded?.author?.[0]?.name;
  const postTitle = post?.title?.rendered || "Golden Triangle Travel Blog";
  const postDescription =
    post?.yoast_head_json?.description ||
    post?.excerpt?.rendered ||
    "Read travel tips and inspiration from Luxury Golden Triangle for private India tours.";

  return (
    <>
      {post && (
        <>
          <SEO
            title={post?.yoast_head_json?.title || `${postTitle} - Luxury Golden Triangle Tour`}
            description={postDescription}
            image={featuredImage}
            type="article"
            canonicalPathOverride={`/${slug}`}
            wpSeo={post?.yoast_head_json}
          />
          {/* HERO SECTION */}
          <HeroLayout>
            <div className="hero">
              <div
                className="banner-bg"
                style={{
                  backgroundImage: `linear-gradient(#370b2e66, #370b2e66), url(${featuredImage})`,
                }}
              >
                <div className="container">
                  <div className="inner-banner-content full-width center color-white mt-5">
                    <h1
                      dangerouslySetInnerHTML={{
                        __html: post.title.rendered,
                      }}
                    />
                    <p>
                      {new Date(post.date).toLocaleDateString()} by {authorName}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </HeroLayout>

          {/* BLOG CONTENT */}
          <div className="blog paddingY-70">
            <div className="container">
              <div className="row">

                {/* LEFT CONTENT */}
                <div className="col-md-12 col-lg-8">
                  <div className="single-blog-card">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: post.content.rendered,
                      }}
                    />
                  </div>
                </div>

                {/* SIDEBAR */}
                <div className="col-md-12 col-lg-4">
                  <div className="recent-bar">

                    {/* Categories */}
                    <div className="recent-bar-card mb-5">
                      <h3 className="mb-4">Categories</h3>
                      {allCategories.map((cat) => (
                        <p key={cat.id}>
                          <Link to={`/category/${cat.slug}`}>
                            {cat.name}
                          </Link>
                        </p>
                      ))}
                    </div>

                    {/* Tags */}
                    <div className="recent-bar-card mb-5">
                      <h3 className="mb-4">Tags</h3>
                      {allTags.map((tag) => (
                        <Link
                          key={tag.id}
                          to={`/tag/${tag.slug}`}
                          className="mb-2 cate-btn d-inline-block"
                        >
                          {tag.name}
                        </Link>
                      ))}
                    </div>

                  </div>
                </div>

              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default SinglePost;
